/* Opus personalizer — modal note + inline email-capture
 * Injected into the Zepto personalizer popup (form/options column #pplr_html) on the Opus PDP.
 * All client-side, with NO add-to-cart and NO product creation:
 *  1. Renders an "Email me my configuration" button. On click it snapshots the customer's current
 *     selections (read live from Zepto's staged line-item property inputs, per Spike A) plus page
 *     constants, hides the button, and reveals the Klaviyo EMBED form INLINE in the button's place
 *     (we inject a klaviyo-form-<id> div; Klaviyo renders into it — spike-verified). No popup overlay.
 *  2. Renders the made-to-order / final-sale "Please note" block BELOW the button (disclaimer after CTA).
 *  3. On the Klaviyo form submit (filtered by formId), fires a `Saved Opus Configuration` event
 *     carrying the snapshot, which triggers the summary flow. The form itself captures email + consent.
 *  4. Adds theme-consistent dismissal: click-outside (on the popup backdrop) and ESC close the popup
 *     (Zepto has no native option) by triggering the popup's own close control.
 *  5. Mobile only: populates the popup header (header.p_h_d > .pplrhleft) with the product title, and
 *     relocates the preview (.pplr-p-left) into Zepto's native scroll container (.pplr-p-right) so the
 *     preview scrolls away WITH the fields while preserving Zepto's touch scrolling. Desktop untouched
 *     (matchMedia-gated).
 * Idempotent (guards by element id), self-guarding (inert unless #pplr_html exists), and resilient
 * (MutationObserver re-injects when Zepto re-renders). Hosted in the theme (Zepto Custom JS save filter
 * rejects this content); loaded only on the Opus PDP template.
 */
(function () {
  var NOTE_ID = 'lunburg-personalize-note';
  var BTN_ID = 'lunburg-email-config-btn';
  var EMBED_ID = 'lunburg-config-embed';
  var FORM_ID = 'UrnqKd';                       // Klaviyo: lunburg__atelier-membership__send_personalization (embed)
  var EVENT_NAME = 'Saved Opus Configuration';

  /* ---- made-to-order note ---- */
  function buildNote() {
    var box = document.createElement('div');
    box.id = NOTE_ID;
    box.style.cssText = 'display:block;clear:both;width:100%;box-sizing:border-box;margin:16px 0 0;padding:14px 16px;border:1px solid #e3ded8;background:#faf8f4;color:#331b0f;font-family:inherit;font-size:13px;line-height:1.6;text-align:left;';
    var title = document.createElement('strong');
    title.style.cssText = 'display:block;margin-bottom:8px;font-family:"EB Garamond",serif;font-weight:400;font-size:11px;letter-spacing:2px;text-transform:uppercase;';
    title.textContent = 'Please note';
    var list = document.createElement('ul');
    list.style.cssText = 'margin:0;padding-left:18px;';
    var li1 = document.createElement('li');
    li1.style.cssText = 'margin-bottom:6px;';
    li1.textContent = 'Personalized pieces are made to order within 3 to 5 weeks, allowing our atelier to place and stamp each mark with precision.';
    var li2 = document.createElement('li');
    li2.textContent = 'Personalized pieces are realized uniquely to your specifications and cannot be returned.';
    list.appendChild(li1);
    list.appendChild(li2);
    box.appendChild(title);
    box.appendChild(list);
    return box;
  }

  /* ---- read current Zepto selections (Spike A recipe; live staged property inputs) ---- */
  function readSelections() {
    var form = document.querySelector('form.pplr_form.pplr_atc_form');
    if (!form) return null;
    var val = function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : null;
    };
    var fontEl = Array.prototype.slice.call(form.querySelectorAll('input,select,textarea'))
      .find(function (e) { return /^properties\[Select .*Font\]$/.test(e.name || ''); });
    var dedicationRaw = val('properties[Dedication]');
    var crestSelected = !!dedicationRaw && /family crest/i.test(dedicationRaw);
    var crestFile = form.querySelector('[name="properties[Family crest]"]');
    return {
      dedicationType: dedicationRaw,
      crestSelected: crestSelected,
      message: crestSelected ? null : val('properties[Dedication message]'),
      fontName: crestSelected ? null : (fontEl ? fontEl.value : null),
      placement: val('properties[Placement]'),
      crestPlacement: crestSelected ? val('properties[Placement]') : null,
      crestFileChosen: !!(crestFile && crestFile.files && crestFile.files.length > 0)
    };
  }

  /* ---- snapshot = selections + page constants (frozen at click) ---- */
  function buildSnapshot() {
    var sel = readSelections() || {};
    var path = location.pathname;
    var handle = (path.split('/products/')[1] || '').split('/')[0] || null;
    var fullTitle = (document.title || '').replace(/\s*\|\s*Lunburg.*/i, '').trim();
    var parts = fullTitle.split(' - ');
    var colorway = parts.length > 1 ? parts[parts.length - 1].trim() : null;
    return {
      model: 'Opus Integral 7',
      colorway: colorway,
      product_handle: handle,
      product_title: fullTitle,
      configuration_url: location.origin + location.pathname,
      dedication_type: sel.dedicationType || null,
      crest_selected: !!sel.crestSelected,
      message_text: sel.message || null,
      font_name: sel.fontName || null,
      placement: sel.placement || null,
      crest_placement: sel.crestPlacement || null
    };
  }

  /* ---- reveal the Klaviyo embed form inline, in the button's slot (Klaviyo renders into the div) ---- */
  function revealForm(anchor) {
    if (document.getElementById(EMBED_ID)) return;
    var wrap = document.createElement('div');
    wrap.id = EMBED_ID;
    wrap.style.cssText = 'margin:14px 0 0;';
    var formDiv = document.createElement('div');
    formDiv.className = 'klaviyo-form-' + FORM_ID;
    wrap.appendChild(formDiv);
    // insert right after the (now hidden) button so the form sits above the note, not at the column end
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(wrap, anchor.nextSibling); }
    else { var host = document.getElementById('pplr_html'); if (host) host.appendChild(wrap); }
  }

  /* ---- "Email me my configuration" button ---- */
  function buildButton() {
    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.type = 'button';
    btn.textContent = 'Email me my configuration';
    btn.style.cssText = 'display:block;width:100%;box-sizing:border-box;margin:14px 0 0;padding:12px 20px;border:1px solid #331b0f;border-radius:0;background:transparent;color:#331b0f;font-family:"EB Garamond",serif;font-size:13px;font-weight:400;letter-spacing:2.34px;text-transform:uppercase;cursor:pointer;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.__opusSnapshot = buildSnapshot();   // freeze selections at click
      btn.style.display = 'none';                 // replace the button...
      revealForm(btn);                            // ...with the inline embed form, in its slot
    });
    return btn;
  }

  var MOBILE_MQ = '(max-width: 768px)';

  /* ---- mobile only: populate the popup header (header.p_h_d > .pplrhleft) with the product title.
   * The sticky mobile header (Block 3 CSS) renders this; the in-scroll .pplr_h_title is hidden on
   * mobile by CSS. Desktop is untouched: the matchMedia gate skips the fill, so the slot stays empty
   * exactly as today. No copy change — the product name is read from the existing .pplr_h_title (with
   * the trailing localized price stripped) and falls back to the page title. ---- */
  function populateMobileHeader() {
    if (!window.matchMedia || !window.matchMedia(MOBILE_MQ).matches) return;   // mobile only
    var header = document.querySelector('.pplr_crop-modal header.p_h_d');
    if (!header) return;
    var slot = header.querySelector('.pplrhleft');
    if (!slot || slot.getAttribute('data-lunburg-hdr') === '1') return;        // idempotent
    var titleEl = document.querySelector('.pplr_crop-modal .pplr_h_title');
    // strip a trailing localized price, e.g. " - €3.250,00" or " - 3.250 00"
    var name = titleEl ? titleEl.textContent.replace(/\s*[-–—]\s*[€$£]?[\d.,\s]+$/, '').trim() : '';
    if (!name) name = (document.title || '').replace(/\s*\|\s*Lunburg.*/i, '').trim();
    if (!name) return;
    var eyebrow = document.createElement('span');
    eyebrow.className = 'lunburg-hdr-eyebrow';
    eyebrow.textContent = 'Personalize';
    var line = document.createElement('span');
    line.className = 'lunburg-hdr-title';
    line.textContent = name;
    slot.innerHTML = '';
    slot.appendChild(eyebrow);
    slot.appendChild(line);
    slot.setAttribute('data-lunburg-hdr', '1');
  }

  /* ---- mobile only: move the preview (.pplr-p-left) into Zepto's native scroll container
   * (.pplr-p-right > .pplr-modal-body) as its first child, so the preview scrolls away WITH the
   * fields. Zepto's mobile scroll element is .pplr-p-right; keeping every scrollable thing inside it
   * preserves iOS touch scrolling (moving the scroll onto the card/form broke finger-scroll).
   * Idempotent and re-applied on Zepto re-render. Desktop untouched (matchMedia-gated). ---- */
  function relocatePreviewMobile() {
    if (!window.matchMedia || !window.matchMedia(MOBILE_MQ).matches) return;   // mobile only
    var modal = document.querySelector('.pplr_crop-modal');
    if (!modal) return;
    var preview = modal.querySelector('.pplr-p-left');
    var scrollBody = modal.querySelector('.pplr-p-right .pplr-modal-body') || modal.querySelector('.pplr-p-right');
    if (!preview || !scrollBody) return;
    if (preview.parentElement === scrollBody && scrollBody.firstElementChild === preview) return; // already placed
    scrollBody.insertBefore(preview, scrollBody.firstChild);
  }

  /* ---- inject button (then note BELOW it) into the popup form column ---- */
  function inject() {
    var target = document.getElementById('pplr_html');
    if (!target) return;
    if (!document.getElementById(BTN_ID) && !document.getElementById(EMBED_ID)) target.appendChild(buildButton());
    if (!document.getElementById(NOTE_ID)) target.appendChild(buildNote());
    populateMobileHeader();
    relocatePreviewMobile();
  }

  /* ---- on Klaviyo form submit (our form only) -> fire the configuration event ---- */
  function onFormSubmit(e) {
    if (!e.detail || e.detail.type !== 'submit' || e.detail.formId !== FORM_ID) return;
    var snap = window.__opusSnapshot || buildSnapshot();
    var fire = function () { try { if (window.klaviyo && klaviyo.track) klaviyo.track(EVENT_NAME, snap); } catch (err) {} };
    var email = (e.detail.metaData && e.detail.metaData.email) || null;
    try {
      if (email && window.klaviyo && klaviyo.identify) {
        var p = klaviyo.identify({ email: email });
        if (p && p.then) { p.then(fire, fire); } else { fire(); }
      } else { fire(); }
    } catch (err) { fire(); }
  }

  /* ---- theme-consistent dismissal: click-outside + ESC close the popup ---- */
  var BACKDROP_SEL = '.pplr_crop-modal';                          // portaled popup backdrop (covers viewport)
  var CLOSE_SEL = 'a.js-modal-close.pplr_close:not(.c_h_m)';      // the VISIBLE close control
  function popupOpen() {
    var bd = document.querySelector(BACKDROP_SEL);
    return !!bd && document.body.classList.contains('pplr_fixed') && getComputedStyle(bd).display !== 'none';
  }
  function closePopup() {
    var x = document.querySelector(CLOSE_SEL);
    if (x) x.click();
  }
  if (!window.__opusCloseShim) {
    document.addEventListener('click', function (e) {
      var bd = document.querySelector(BACKDROP_SEL);
      if (bd && e.target === bd && popupOpen()) closePopup();     // click only on the dark backdrop, not the card
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && popupOpen()) closePopup();
    });
    window.__opusCloseShim = true;
  }

  inject();
  new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
  if (!window.__opusFormListener) {
    window.addEventListener('klaviyoForms', onFormSubmit);
    window.__opusFormListener = true;
  }
})();
